import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import moment from 'moment';

class Ventas extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'Ventas', saveUrl: 'Ventas/save', backUrl: '/Catalogo' },
      new Form([
        Form.Field('date', 'startDate', 'Fecha Inicial', '', [Validators.required], 6),
        Form.Field('date', 'endDate', 'Fecha Final', '', [Validators.required], 6),
        Form.Field('select', 'type', 'Tipo', '', [Validators.required], 6, [
          { Label: 'Normal', Value: '1' },
          { Label: 'Sin Redocumentaciones del mes', Value: '2' },
          { Label: 'Sin Redocumentaciones de meses anteriores', Value: '3' },
          { Label: 'Sin Redocumentaciones', Value: '4' },
        ]),
      ], ['Descargar Excel'], 'Ventas'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  onSubmit = async (i, vals) => {
    this.setState({ loading: true });
    const { startDate, endDate, type } = vals;
    const start = moment(startDate).format('YYYY-MM-DD');
    const end = moment(endDate).format('YYYY-MM-DD');
    const Resp = await Http.get(`reporte/ventas?q=1&start_date=${start}&end_date=${end}&type=${type}`, true, 'arraybuffer')
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
      const a = document.createElement('a');
      const url = URL.createObjectURL(blob)
      a.style.display = 'none';
      a.href = url;
      a.download = `reporte_ventas_${start}-${end}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      this.setState({ sbOpen: true, sbMsg: 'Ocurrio un error al generar el archivo' });
    }
    this.setState({ loading: false });
  }

  render() {
    return (
      <div>
        <this.FormRender on />
      </div>
    )
  }
}

export default withRouter(Ventas)
